import { isViewOnlyModeAtom, Service } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import classNames from "classnames";
import { Node } from "reactflow";

import useUpdateNode from "../../../hooks/useUpdateNode";
import useServiceById from "../../../hooks/useServiceById";
import { AppItemIcon } from "../AppTypeahead";
import { SidebarListItem } from "../SidebarListItem";

import styles from "./AppList.module.css";

export function AppList({
  nodeId,
  services,
  node,
}: {
  nodeId: string;
  services: Service[];
  node: Node;
}) {
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);
  const updateNodeAndSave = useUpdateNode();
  const appId = services?.[0]?.currentImplementation.id ?? "";
  const getService = useServiceById();
  const service = getService(appId);

  const initialSelectedItem =
    service ??
    (node.data.app
      ? {
          name: node.data.app,
          app_id: appId,
        }
      : undefined);
  function onRemoveApp() {
    updateNodeAndSave({
      id: nodeId,
      data: {
        services: undefined,
        app: undefined,
      },
    });
  }

  if (!initialSelectedItem || !services?.[0]) {
    return null;
  }

  const listStyles = classNames(styles.appList, {
    [styles.row]: isViewOnlyMode,
  });

  return (
    <ul className={listStyles}>
      <SidebarListItem
        icon={<AppItemIcon item={services?.[0]} />}
        label={initialSelectedItem.name}
        onRemove={isViewOnlyMode ? undefined : onRemoveApp}
        key={initialSelectedItem.app_id}
        isViewOnly={isViewOnlyMode}
      />
    </ul>
  );
}
